import { render, staticRenderFns } from "./BizAgreementinfoForm.vue?vue&type=template&id=77528424&"
import script from "./BizAgreementinfoForm.vue?vue&type=script&lang=js&"
export * from "./BizAgreementinfoForm.vue?vue&type=script&lang=js&"
import style0 from "./BizAgreementinfoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports